import { render, staticRenderFns } from "./EnvironmentsLists.vue?vue&type=template&id=45974e8f&scoped=true"
import script from "./EnvironmentsLists.vue?vue&type=script&lang=ts"
export * from "./EnvironmentsLists.vue?vue&type=script&lang=ts"
import style0 from "./EnvironmentsLists.vue?vue&type=style&index=0&id=45974e8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45974e8f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VSlideYTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VChip,VIcon,VListItem,VListItemAvatar,VListItemContent,VListItemSubtitle,VListItemTitle,VPagination,VSlideYTransition})
